import {floatFormatter} from '../Common/util';

// 취약점진단통계
export const summaryColumnData = [
    {
        title: '분류',
        align: 'center',
        colSpan: 2,
        rowSpan: 2,
        children: [
            {
                title: ' ',
                dataIndex: 'code',
                key: 'code',
                width: '70px',
                align: 'center',
                ellipsis : true,
                sorter: (a, b) => a.code.length - b.code.length,
                colSpan : 0,
            },
            {
                title: ' ',
                dataIndex: 'name',
                key: 'name',
                width: '150px',
                align: 'center',
                ellipsis : true,
                colSpan : 0,
            },
        ]
    },
    {
        title: '위험평가 결과',
        align: 'center',
        children: [
            {
                title: '전체항목',
                dataIndex: 'total',
                key: 'total',
                width: '60px',
                align: 'center',
                ellipsis : true,
            },
            {
                title: '전체위험',
                dataIndex: 'total_risk',
                key: 'total_risk',
                width: '60px',
                align: 'center',
            },
            {
                title: 'H',
                dataIndex: 'H',
                key: 'Y',
                width: '60px',
                align: 'center',
            },
            {
                title: 'M',
                dataIndex: 'M',
                key: 'N',
                width: '60px',
                align: 'center',
            },
            {
                title: 'L',
                dataIndex: 'L',
                key: 'P',
                width: '60px',
                align: 'center',
            },
            {
                title: '위험도(%)',
                dataIndex: 'risk_rate',
                key: 'risk_rate',
                width: '60px',
                align: 'center',
                className: 'fix_col',
                render: (_ , rowData ) => {
                    return (
                        <>
                            {floatFormatter(rowData.total_risk / rowData.total * 100, 1)}%
                        </>
                    );
                },
            }, 
        ]
    },
    {
        title: '위험 관리 비율',
        align: 'center',
        children: [

            {
                title: '관리대상(DOA)',
                dataIndex: 'DoaCount',
                key: 'DoaCount',
                width: '60px',
                align: 'center',
            },
            {
                title: '관리위험',
                dataIndex: 'ManagedRisks',
                key: 'ManagedRisks',
                width: '60px',
                align: 'center',
                render: (_ , rowData ) => {
                    return (
                        <>
                            {rowData.ManagedRisks}%
                        </>
                    );
                },
            },
            {
                title: '잔여위험',
                dataIndex: 'UnmanagedRisks',
                key: 'UnmanagedRisks',
                width: '60px',
                align: 'center',
                render: (_ , rowData ) => {
                    return (
                        <>
                            {rowData.UnmanagedRisks}%
                        </>
                    );
                },
            },
        ]
    },
];
